module.exports = __webpack_public_path__ + "img/storage.01f9bb6a.jpg";